import React, { useState, useEffect, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import AccountCircle from "@material-ui/icons/AccountCircle"
import InputAdornment from "@material-ui/core/InputAdornment"
import Button from "@material-ui/core/Button"
import Container from "@material-ui/core/Container"
import { userNewUserVerification, userNewUserResendToken } from "@/apis"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"
import { emailFormatCheck } from "@/utils"
import { useSearchParams } from "react-router-dom"
import PasswordReset from "./PasswordReset"

const useStyles = makeStyles((theme) => ({
    title: {
        textAlign: "center",
        marginBottom: theme.spacing(5),
        marginTop: theme.spacing(7),
    },
}))

const NewUserVerify = memo(() => {
    const classes = useStyles()
    const [errorMsg, setErrorMsg] = useState("")
    const [userEmail, setUserEmail] = useState("")
    const [verifyEmail, setVerifyEmail] = useState()
    const [errorMsgResendToken, setErrorMsgResendToken] = useState({
        error: false,
        errorMsg: "",
        display: false,
    })
    const confirmSnackbarValue = useHandleRequestSnackbar(errorMsgResendToken)
    const [searchParams] = useSearchParams()
    const verifyToken = searchParams.get("token")
    const [validate, setValidate] = useState()
    useEffect(() => {
        // validate token
        const validateToken = async () => {
            try {
                const result = await userNewUserVerification(verifyToken)
                setVerifyEmail(result.data.email)
                setValidate(true)
            } catch (e) {
                setValidate(false)
            }
        }
        if (verifyToken) {
            validateToken()
        } else {
            setValidate(false)
        }
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault()
        const emailFormatCheckStatus = emailFormatCheck(userEmail)
        if (!userEmail) setErrorMsg("Please input email")
        else if (!emailFormatCheckStatus) {
            setErrorMsg("Email format is wrong")
        } else if (errorMsg === "") {
            const email = userEmail
            try {
                const result = await userNewUserResendToken({ email })
                setErrorMsgResendToken({
                    display: true,
                    error: false,
                    message: result.data.message,
                })
            } catch (error) {
                setErrorMsgResendToken({
                    display: true,
                    error: true,
                    message: "Error",
                })
            }
        }
    }
    return (
        <Box>
            <Typography component="h1" variant="h4" className={classes.title}>
                Validation New User
            </Typography>
            {validate ? (
                <>
                    <Typography className={classes.title}>New user has been verified, please set up password</Typography>
                    <PasswordReset child verifyEmail={verifyEmail} />
                </>
            ) : (
                <>
                    <Typography className={classes.title}>Verify New User is failed</Typography>
                    <Container component="main" maxWidth="xs">
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item xs={12}>
                                <TextField
                                    className={classes.inputField}
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    autoComplete="email"
                                    autoFocus
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountCircle />
                                            </InputAdornment>
                                        ),
                                    }}
                                    error={!!errorMsg}
                                    helperText={errorMsg}
                                    onChange={(e) => {
                                        setUserEmail(e.target.value)
                                        setErrorMsg("")
                                    }}
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={handleSubmit}
                                >
                                    Resend activation email
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                </>
            )}
            {errorMsgResendToken.display && (
                <RequestSnackbar
                    status={!errorMsgResendToken.error}
                    message={errorMsgResendToken.message}
                    snackbarOpen={confirmSnackbarValue.snackbarOpen}
                    handleSnackbarOpenStatus={confirmSnackbarValue.handleSnackbarOpenStatus}
                />
            )}
        </Box>
    )
})

export default NewUserVerify
